
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
  DialogDescription,
} from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";
import { ExternalLink, Loader2 } from "lucide-react";

interface PricingModalProps {
  isOpen: boolean;
  onClose: () => void;
  onUpgradeClick: (type: 'monthly' | 'yearly') => void;
  checkoutUrl?: string | null;
  isLoading?: boolean;
}

export const PricingModal = ({ isOpen, onClose, onUpgradeClick, checkoutUrl, isLoading = false }: PricingModalProps) => {
  return (
    <Dialog open={isOpen} onOpenChange={onClose}>
      <DialogContent className="sm:max-w-[425px]">
        <DialogHeader>
          <DialogTitle>Upgrade Your Plan</DialogTitle>
          <DialogDescription>
            You've used all your free transformations! Choose a plan to continue transforming recipes.
          </DialogDescription>
        </DialogHeader>
        <div className="grid gap-4 py-4">
          <div className="space-y-4">
            <div className="bg-primary/5 p-4 rounded-lg space-y-2">
              <h3 className="font-semibold">Monthly Plan</h3>
              <p className="text-sm text-muted-foreground">$5/month - Unlimited transformations</p>
              <Button
                className="w-full"
                onClick={() => onUpgradeClick('monthly')}
                disabled={isLoading}
              >
                {isLoading ? (
                  <>
                    <Loader2 className="mr-2 h-4 w-4 animate-spin" />
                    Processing...
                  </>
                ) : (
                  "Choose Monthly"
                )}
              </Button>
            </div>
            <div className="bg-primary/5 p-4 rounded-lg space-y-2">
              <h3 className="font-semibold">Yearly Plan</h3>
              <p className="text-sm text-muted-foreground">$50/year - Save $10!</p>
              <Button
                variant="outline"
                className="w-full"
                onClick={() => onUpgradeClick('yearly')}
                disabled={isLoading}
              >
                {isLoading ? (
                  <>
                    <Loader2 className="mr-2 h-4 w-4 animate-spin" />
                    Processing...
                  </>
                ) : (
                  "Choose Yearly"
                )}
              </Button>
            </div>
            
            {checkoutUrl && (
              <div className="mt-4 p-3 border border-yellow-300 bg-yellow-50 rounded-lg">
                <p className="text-sm text-yellow-800 mb-2">
                  If the checkout page doesn't open automatically, please click the button below:
                </p>
                <Button 
                  variant="outline" 
                  className="w-full flex items-center justify-center gap-2"
                  onClick={() => window.open(checkoutUrl, '_blank')}
                >
                  Open Checkout <ExternalLink size={16} />
                </Button>
              </div>
            )}
          </div>
        </div>
      </DialogContent>
    </Dialog>
  );
};
